
import Vue from "vue";

export default Vue.extend({
  name: "OpenNumbers",
  components: {
  },
  props: {
    numbers: Array,
    startIndex: Number,
  },
});

